import '../../Styles/serviceComponenetsStyles/ui.css'
import uiImage from '../../Assets/uiImg.png'

export default function Uidesign() {
  return (
    <div className='Uidesign'>
        <div className="uiContainer">
            <div className="uileft">
                <div className="uilefttop">UI DESIGNING</div>
                <div className="uileftbottom">
                    A well-crafted UI ensures a seamless user experience, fostering<br></br>
                    engagement and creating lasting impressions. Our UI design<br></br>
                    experts bring creativity and functionality together to elevate your<br></br>
                    digital presence, making every interaction a delight for your users</div>
            </div>
            <div className="uiRight">
                <div className="uiRightImg">
                    <img src={uiImage} alt="uiImage" />
                </div>
            </div>
        </div>
    </div>
  )
}
